import {
  Box,
  Center,
  Heading,
  Text,
  Image as ChakraImage,
} from '@chakra-ui/react';
import { useMount } from 'react-use';
import Image from 'next/image';

import Page from '@inspire/ui/chakra/layout/Page';
import Panel from '@inspire/ui/general/Panel';

import { useBeacon } from 'lib/hooks';
import { BEACON_PROF_NAV_MODULES } from 'lib/local-store-keys';

const ProfDashboardPage = () => {
  const { disable: disableNavModulesBeacon } = useBeacon(
    BEACON_PROF_NAV_MODULES
  );

  useMount(() => disableNavModulesBeacon());

  return (
    <Page title={'Accueil'}>
      <Heading size="lg" textAlign="center">
        Avec INSPIRE vous pouvez…
      </Heading>

      <Box background="#444" color="white" as={Panel} mt="5">
        <Heading color="white" size="md" textAlign="center">
          PRÉPARER VOS SÉANCES SUR L’ORIENTATION AVEC NOS RESSOURCES INSPIRE
        </Heading>
        <Text>
          Vous pouvez sélectionner les contenus pédagogiques pertinents en
          fonction des besoins de vos élèves et suivre leurs activités sur le
          site.
        </Text>
        <Heading color="white" size="sm">
          LE KIT DE SURVIE
        </Heading>
        <Text>
          Pour aider vos élèves à passer le cap en ayant plus de détails sur les
          aides financières, les logements, les aides à la mobilité, ou encore
          les bons plans étudiants.
        </Text>
        <Center mb={10}>
          <Image
            src="/img/gif/kitdesurvie.gif"
            alt="kitdesurvie"
            width="570px"
            height="319px"
          />
        </Center>
      </Box>

      <Box as={Panel} mt="5">
        <Heading size="md" textAlign="center">
          DÉCOUVREZ NOS PARCOURS PÉDAGOGIQUES EN LIGNE
        </Heading>
        <Text>
          Pour accompagner vos élèves de la 2nde à la Tale dans leur projet de
          poursuite d’études ou d’insertion professionnelle à travers des
          modules interactifs.
        </Text>
        <Center mt={10} mb={10}>
          <ChakraImage
            alt="Voie professionnelle"
            maxW={['100%', 600]}
            src="/img/gif/voie-prof.gif"
          />
        </Center>
      </Box>

      <Box background="#444" color="white" as={Panel} mt="5">
        <Heading color="white" size="md" textAlign="center">
          ACCOMPAGNEZ VOS ELEVES SUR LA PLATEFORME INSPIRE
        </Heading>
        <Text>
          Une fois inscrits sur{' '}
          <a href="https://inspire-orientation.org/" style={{ color: '#fff' }}>
            inspire-orientation.org
          </a>
          , vos élèves auront accès à des pistes d'études recommandées en
          fonction de leur profil. Ils auront également accès aux modules en
          autonomie, adaptés à leur niveau.
        </Text>
        <Text>
          Les lycéens peuvent utiliser INSPIRE pour contacter des étudiants
          Eclaireurs issus des pistes d'études qui les intéressent, afin de leur
          poser des questions sur leurs études. Ces étudiants sont bénévoles.
        </Text>
      </Box>
    </Page>
  );
};

export default ProfDashboardPage;
